import { createContext } from 'react';

// The set of currently selected investor ids, read only by each card's small
// checkbox. Passing `selected` down as a prop made every (heavy) InvestorCard
// re-render on each selection change; going through context lets the memoized
// card bodies stay put while just the checkboxes update.
export default createContext(new Set());
